import React, { ChangeEvent, DetailedHTMLProps, useCallback, useMemo, useState } from "react"


const FileInput = React.forwardRef<HTMLInputElement, Props>( ( { className: _className, onChange, ...props }, ref ) => {

    const [ fileNames, setFileNames ] = useState<string[]>( [] )

    const className = useMemo( () => {
        return [
            'w-full focus:outline-none h-12 border px-2 flex items-center',
            ...( _className?.split( ' ' ) ?? [] )
        ].join( ' ' )
    }, [ _className ] )

    const _onChange = useCallback( ( e:ChangeEvent<HTMLInputElement> ) => {
        setFileNames( Array.from( e.currentTarget.files ?? [] ).map( f => f.name ) )
        onChange && onChange( e )
    }, [ onChange ] )

    return (
        <div  className={ className }>
            { fileNames.join( ', ') }
            <input
                className="hidden"
                ref={ ref }
                type="file"
                onChange={ _onChange }
                { ...props }
            />
        </div>
    )
})

interface Props extends DetailedHTMLProps<any, HTMLInputElement> {

}

export { FileInput }
